import * as React from 'react'
import cx from 'classnames'
import styles from './styles.module.scss'

interface Props {
  title: string
  className: string
}

export const Section: React.FC<Props> = ({title, className, children, ...rest}) => {
  return (
    <section className={cx(className, styles.section)} {...rest}>
      <h3>{title}</h3>
      {children}
    </section>
  )
}
